import { Fragment, jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import { withDefaultAriaLabel } from "@/aria";
import { cx } from "@/lib/cx";
import { omitProps } from "@/lib/omit-props";
import { RuiIconChevronDown } from "@/lib/icons";
import { RuiListbox } from "../listbox";
import "./select.script";
export function RuiSelectControl({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    class: cx("rui-select__control", className),
    children
  });
}
export function RuiSelectTrigger({
  children,
  class: className,
  disabled,
  ...props
}) {
  return /* @__PURE__ */jsx("button", {
    ...omitProps(props, "attr:type"),
    type: "button",
    "data-select-trigger": true,
    "data-rui-control": true,
    "data-rui-control-type": "text",
    class: cx("rui-select__trigger", className),
    disabled,
    children
  });
}
export function RuiSelectToggle({
  children,
  class: className,
  aria,
  disabled,
  ...props
}) {
  return /* @__PURE__ */jsx("button", {
    ...props,
    aria: withDefaultAriaLabel(aria, "Show options"),
    type: "button",
    "data-select-toggle": true,
    class: cx("rui-control-toggle", className),
    disabled,
    tabIndex: -1,
    children: children ?? /* @__PURE__ */jsx(RuiIconChevronDown, {})
  });
}
export function RuiSelectValue({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("span", {
    ...props,
    "data-select-value": true,
    class: cx("rui-select__value", className),
    children
  });
}
export function RuiSelectListbox({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    "data-select-listbox": true,
    class: cx("rui-select__listbox rui-popover rui-popover--listbox rui-floating", className),
    children
  });
}
export function RuiSelectSearch({
  placeholder,
  class: className,
  disabled,
  ...props
}) {
  return /* @__PURE__ */jsx("input", {
    ...props,
    type: "search",
    "data-autocomplete-input": true,
    class: cx("rui-select__search", className),
    placeholder,
    disabled,
    autocomplete: "off"
  });
}
function resolveSelectDisplayText(options, value, placeholder) {
  const selected = typeof value === "string" ? value.trim() : "";
  const fallback = typeof placeholder === "string" ? placeholder : "";
  if (!selected) {
    return fallback;
  }
  const match = options?.find(option => option.value === selected);
  if (!match) {
    return selected;
  }
  return typeof match.label === "string" ? match.label : selected;
}
function SelectShell({
  children
}) {
  return /* @__PURE__ */jsx("div", {
    class: "rui-select",
    "data-ref": "root",
    children
  });
}
export function RuiSelect({
  options,
  children,
  ...props
}) {
  const displayText = options != null ? resolveSelectDisplayText(options, props.value, props.placeholder) : "";
  return /* @__PURE__ */jsx("rui-select", {
    ...props,
    children: /* @__PURE__ */jsx(SelectShell, {
      children: options == null ? children : /* @__PURE__ */jsxs(Fragment, {
        children: [/* @__PURE__ */jsxs(RuiSelectControl, {
          children: [/* @__PURE__ */jsx(RuiSelectTrigger, {
            children: /* @__PURE__ */jsx(RuiSelectValue, {
              children: displayText
            })
          }), /* @__PURE__ */jsx(RuiSelectToggle, {})]
        }), /* @__PURE__ */jsx(RuiSelectListbox, {
          children: /* @__PURE__ */jsx(RuiListbox, {
            embedded: true,
            options
          })
        })]
      })
    })
  });
}